import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

interface IStyles {
    backgroundColor?: string;
    backgroundImage?: string;
}
export const useStyles = makeStyles<IStyles>()(
    (theme, { backgroundColor = "transparent", backgroundImage }) => ({
        outer: {
            width: "100%",
            maxWidth: "1440",
            height: "960px",
            backgroundColor: constants.color.white,
            position: "relative",
            marginTop: "-220px",
        },
        root: {
            width: "100%",
            maxWidth: "1440",
            height: "960px",
            background: backgroundImage
                ? `url(${backgroundImage})`
                : backgroundColor,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            display: "flex",
            color: constants.color.white,
            alignSelf: "center",
            justifySelf: "center",
            transformOrigin: "bottom center",
            transform: "scale(0.85) translateY(140px)",
        },

        header: {
            width: "100%",
            maxWidth: "898px",
            minHeight: "450px",
        },
        gradient: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            width: "100%",
            height: "100%",
            background:
                "rgba(0, 0, 0, 0.3)",
            alignItems: "center",
            justifyContent: "center",
        },
        headerContainer: {
            width: "638px",
            display: "flex",
            fontFamily: "Gotham Book",
            fontSize: "110px",
            fontWeight: 450,
            lineHeight: "110px",
            letterSpacing: "2px",
            textAlign: "center",
            textTransform: "uppercase",
        },
    })
);
